<template>
  <v-dialog persistent v-model="open" class="opa" max-width="800">
    <v-card
      class="py-2 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8 rounded-xl secondaryBackground"
    >
      <v-card-title class="pb-3 pb-sm-10 pb-lg-10 pb-xl-10 pb-md-10">
        <v-row>
          <v-col sm="12" class="justify-center d-flex">
            <img
              alt="Logo"
              width="180"
              class="rounded-0 text-center"
              :src="require('@/assets/svg/logo.svg')"
            />
          </v-col>
        </v-row>
        <v-btn icon @click="$emit('close', true)" left>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="pb-2 pb-sm-10 pb-md-10 pb-lg-10 pb-xl-10"></v-divider>
      <v-card-text id="change-email-modal">
        <v-layout row wrap align-center>
          <v-flex>
            <v-form ref="form" :lazy-validation="false">
              <v-row class="justify-center" v-if="errorSummary !== null">
                <v-col col="12" md="7" xl="7" lg="7" sm="7" class="pb-0">
                  <v-alert class="error" id="error" type="info" dense icon="mdi-information-outline"
                    >{{ errorSummary }}
                  </v-alert>
                </v-col>
              </v-row>
              <v-row class="justify-center">
                <v-col col="12" md="7" xl="7" lg="7" sm="12">
                  {{ $t('email-tooltip') }}
                </v-col>
                <v-col col="12" md="7" xl="7" lg="7" sm="12">
                  <label class="text-bold subtitle-2">{{ $t('new-email') }}</label>
                  <v-text-field
                    class="pt-2"
                    v-model="request.email"
                    :placeholder="$t('new-email')"
                    outlined
                    required
                    :rules="emailRules()"
                  >
                  </v-text-field>
                </v-col>
                <v-col col="12" md="7" xl="7" lg="7" sm="12" class="pt-0 mt-0">
                  <label class="text-bold subtitle-2">{{ $t('verify-email') }}</label>
                  <v-text-field
                    class="pt-2"
                    v-model="request.verifyEmail"
                    :placeholder="$t('verify-email')"
                    outlined
                    required
                    :rules="confirmEmailRules().concat(checkEmail)"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="justify-center">
                <v-col
                  col="12"
                  md="5"
                  xl="5"
                  lg="5"
                  sm="12"
                  class="d-flex pt-1 pt-sm-7 pt-xl-7 pt-md-7 pt-lg-7 align-center"
                >
                  <v-btn
                    large
                    class="rounded-lg pl-10 pr-10 white--text change-button"
                    color="neutral"
                    block
                    :disabled="!request"
                    @click="updateEmail()"
                    >{{ $t('save') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import EventBus from '@/helpers/event-bus';
import util from '@/mixins/util';
import service from '@/services/profile-service.js';
import i18n from '@/i18n';

export default {
  name: 'ChangeEmail',
  props: {
    changeEmail: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [util, service],
  data() {
    return {
      errorSummary: null,
      request: {
        email: null,
        verifyEmail: null,
      },
      open: false,
    };
  },
  methods: {
    updateEmail() {
      const isFormValid = this.$refs.form.validate();
      if (isFormValid) {
        console.log('test', isFormValid);
        console.log('update Email');
        this.postEmail(this.request)
          .then(() => {
            EventBus.$emit('snackbar', {
              text: this.$i18n.t('email-changed'),
            });
            setTimeout(() => {
              this.logout();
            }, '2000');
          })
          .catch(error => {
            console.log(error);
            if (error.response.status === 409) {
              EventBus.$emit('snackbar', {
                text: 'This email is assigned to another user',
                color: 'error',
              });
            }
          });
      }
    },
  },
  computed: {
    checkEmail() {
      return () => this.request.email === this.request.verifyEmail || i18n.t('matching-email-rule');
    },
  },
  watch: {
    changeEmail: {
      handler: function() {
        this.open = this.changeEmail;
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
